import { SharedContent } from './shared-content';

export const NewAccountReviewContent = {
  pageIDHeader: 'Account ',
  pageTitle: 'Please review your application to open an account',
  progressLabelIT: 'Internal transfer progress',
  progressLabelITOpenAccount: SharedContent.progressLabelITOpenAccount,
  accountHatPrefix: SharedContent.accountHatPrefix,
  continueButton: SharedContent.buttons.continueButton,
  progressButtons: {
    transfer: 'Transfer another account',
    review: 'Review and sign',
  },
  banner: {
    header: 'Important information about your new account',
    content: `Your new account won't officially be opened until you finish this entire process and submit the information for <em>all</em> of your accounts.`,
  },
};
